import { useQuery } from "@tanstack/react-query";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";

export type TrainRoutesResponse = (TrainRoute | null)[];

export type TrainRouteRequestBody = TrainIdentifier[];

export const useTrainRoutes = (trainIds: TrainRouteRequestBody) => {
  const { status, data, isSuccess, refetch } = useQuery({
    queryKey: ["trainRoutes", JSON.stringify(trainIds)],
    queryFn: ({ signal }) =>
      axiosClient
        .post<TrainRoutesResponse>(
          `${getBackendUrl()}/trainRoute/trains`,
          trainIds,
          { signal },
        )
        .then((res) => (trainId: TrainIdentifier) => {
          const trainRoute = res.data.find(
            (route) => route?.trainId === trainId.identifier,
          );
          if (!trainRoute) return undefined;
          return trainRoute;
        }),
    enabled: trainIds.length > 0,
  });

  return { status, data, isSuccess, refetch };
};
